import React, { useState } from 'react';

const links = [
  { label: 'Services', href: '#services' },
  { label: 'Delivery', href: '#delivery' },
  { label: 'About', href: '#about' },
  { label: 'Contact', href: '#contact' },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <nav className="navbar">
      <a href="#home" className="brand" aria-label="Arthanova Global home">
        <img
          src="/arthanova_logo.png"
          alt="Arthanova Global"
          className="brand-logo"
        />
      </a>

      <button
        type="button"
        className="menu-button"
        onClick={() => setOpen((value) => !value)}
        aria-label="Toggle navigation"
      >
        ☰
      </button>

      <div className={`nav-links ${open ? 'open' : ''}`}>
        {links.map((link) => (
          <a key={link.href} href={link.href} onClick={() => setOpen(false)}>
            {link.label}
          </a>
        ))}
      </div>
    </nav>
  );
}